import React, { useEffect } from 'react';
import APIServices from 'services/APIServices';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { selectLoader } from 'utils/Helpers';
import leftArrow from 'assets/img/white-left-icon.svg';
import Header from 'components/Header';
import ProjectBoardWrapperPage from '../Board';
import './TemplatesPreview.css';

const TemplatesPreview = () => {
  const { templateId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const backUrl = location.state?.backUrl || `/`;
  const [isLoading, setIsLoading] = React.useState(false);
  const [loadError, setLoadError] = React.useState('');
  const [projectDetail, setProjectDetail] = React.useState(null);
  const [channels, setChannels] = React.useState(null);

  const fetchTemplateDetails = async (templateId) => {
    try {
      setIsLoading(true);
      setLoadError('');
      let response = await APIServices.get(`/project-board-templates/${templateId}`);
      if (response) {
        setChannels(response?.channels);
        setProjectDetail(response);
      } else {
        throw new Error('No template found.');
      }
    } catch (error) {
      console.error('Error fetching template:', error.message || error);
      setLoadError('We could not load this template. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchTemplateDetails(templateId);
  }, [templateId]);

  const handleBackClick = () => {
    navigate('/templates', { state: { currentTab: 'kanban', backUrl } }); // This goes back to the previous page
  };

  const HeaderContent = (
    <>
      <h2>
        <span className="preview-title">Preview</span>
      </h2>
      <div className="head-right">
        {/* {isUser1 && hasPermission(userRole, 'update_projects') && (
          <div
            onClick={() => {
              navigate(`/project-boards`);
            }}>
            <img src={KanbanIcon} alt="kanban" style={{ cursor: 'pointer' }} />
          </div>
        )} */}
        {/* <a>
          <img
            src={settingIcon}
            alt="menu"
            className="feather-img menuicon"
            onClick={() => {
              navigate("/settings");
            }} // Sidebar toggle handler
          />
        </a> */}
        {/* <Dropdown className="notify-drp">
          <Dropdown.Toggle
            as="a"
            className="dropdown-toggle"
            onClick={() => {
              toggleModal('notifications', true);
              setUnread(false);
            }}>
            {isUnread ? (
              <img src={notificationIcon} alt="comp1" className="notification-img" />
            ) : (
              <img src={bellIcon} alt="comp1" className="notification-img" />
            )}
          </Dropdown.Toggle>
        </Dropdown> */}
        <a onClick={handleBackClick}>
          <img src={leftArrow} alt="comp1" className="left-arrow" />
        </a>
      </div>
    </>
  );

  return (
    <div className="wrapper create_project templates-preview-page">
      <Header content={HeaderContent} />
      <div className="main-content">
        <section className="dashboard-sec templates-preview-screen">
          <div className="template-preview-container">
            
            <div className="template-preview-board">
              {isLoading ? (
                <div className="template-preview-state" role="status">
                  {selectLoader(56)}
                  <p>Loading template…</p>
                </div>
              ) : loadError ? (
                <div className="template-preview-state template-preview-error" role="alert">
                  <h2>Template unavailable</h2>
                  <p>{loadError}</p>
                  <button type="button" onClick={() => fetchTemplateDetails(templateId)}>
                    Try again
                  </button>
                </div>
              ) : (
                <ProjectBoardWrapperPage
                  projectBoardId={''}
                  setBoards={[]}
                  channels={channels}
                  projectDetail={projectDetail}
                  isTemplateActive={true}
                  fetchTemplates={null}
                  activeTemplateId={templateId}
                  parentBoardId={''}
                  fetchProjectBoards={''}
                  isGeneralPreview={true}
                  onTemplateRenamed={(name) =>
                    setProjectDetail((current) => (current ? { ...current, name } : current))
                  }
                  onTemplateDeleted={() => navigate('/templates', { state: { currentTab: 'kanban', backUrl } })}
                />
              )}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default TemplatesPreview;
